import { useState } from "react";
import ReactDOM from "react-dom";
import { X, ChevronLeft, ChevronRight } from "lucide-react";
import { createPortal } from "react-dom";
import './Projects.css'; // Importing the CSS file
import Header from '../components/Header';
import Dashboard from '../components/Dashboard';
import Cardlist from '../components/Cardlist';
import Footer from '../components/Footer';
// import Addbutton from "../assets/project_img/images/Addbutton.svg";



import peekaboo2 from "../assets/gem_products/peekaboo/Peekaboo24.JPG";
import peekaboo5 from "../assets/gem_products/peekaboo/Peekaboo27.JPG";
import peekaboo11 from "../assets/gem_products/peekaboo/Peekaboo33.JPG";
import peekaboo14 from "../assets/gem_products/peekaboo/Peekaboo36.JPG";
import peekaboo17 from "../assets/gem_products/peekaboo/Peekaboo40.JPG";
import peekaboo18 from "../assets/gem_products/peekaboo/Peekaboo41.JPG";
import peekaboo19 from "../assets/gem_products/peekaboo/Peekaboo42.JPG";
import peekaboo20 from "../assets/gem_products/peekaboo/Peekaboo43.JPG";
import peekaboo22 from "../assets/gem_products/peekaboo/Peekaboo45.JPG";
import peekaboo25 from "../assets/gem_products/peekaboo/Peekaboo47.JPG";
import peekaboo31 from "../assets/gem_products/peekaboo/Peekaboo31.MP4";
import peekaboo32 from "../assets/gem_products/peekaboo/Peekaboo37.MP4";



import irbid1 from "../assets/gem_products/irbid/irbid2.JPG";
import irbid3 from "../assets/gem_products/irbid/irbid4.jpg";
import irbid4 from "../assets/gem_products/irbid/irbid5.jpg";
import irbid5 from "../assets/gem_products/irbid/irbid6.jpg";
import irbid6 from "../assets/gem_products/irbid/irbid7.jpg";
import irbid9 from "../assets/gem_products/irbid/irbid10.jpg";
import irbid10 from "../assets/gem_products/irbid/irbid1.MP4";


import babyday2 from "../assets/gem_products/babyday/babyday2.jpg";
import babyday8 from "../assets/gem_products/babyday/babyday8.jpg";
import babyday12 from "../assets/gem_products/babyday/babyday12.jpg";
import babyday14 from "../assets/gem_products/babyday/babyday14.jpg";
import babyday15 from "../assets/gem_products/babyday/babyday15.jpg";
import babyday16 from "../assets/gem_products/babyday/babyday16.jpg";
import babyday18 from "../assets/gem_products/babyday/babyday18.jpg";
import babyday19 from "../assets/gem_products/babyday/babyday19.MOV";
//import babyday1 from "../assets/gem_products/babyday/babyday1.jpg";






// import img8 from "../assets/project_img/images/img8.svg";
import project from "../assets/img/imagefile/imagefile/project_img.png"
import plusicon from '../assets/img/product_img/plusicon.png';
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import WhatsappButton from '../components/WhatsappButton';




const Modal = ({ onClose, children }) => {
  return createPortal(
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={onClose} // close on backdrop click
    >
      <div
        className="bg-white rounded-2xl p-6 shadow-lg relative w-96"
        onClick={(e) => e.stopPropagation()} // prevent backdrop close
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-600 hover:text-black"
        >
          ✕
        </button>

        {children}
      </div>
    </div>,
    document.body // 👈 important: render modal into <body>
  );
};

const Projects = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/GetQuotation'); 
  };
  let description = (<><h2 className="ProjectContent">From concept to execution, Global Entertainment Manufacturer, we are a leading supplier in the location-based entertainment industry. Whether it's an indoor playground or a trampoline park, as a trusted Trampoline Park Manufacturer in Jordan, we deliver high-quality, innovative solutions tailored to your needs</h2></>)
  
   const babydayimages = [
    { type: "img", src: babyday2 },
    { type: "img", src: babyday15 },
    { type: "img", src: babyday12 },
    { type: "img", src: babyday8 },
    { type: "img", src: babyday14 },
    { type: "img", src: babyday16 },
    { type: "img", src: babyday18 },
    { type: "video", src: babyday19 },
  ];

  const irbidimages = [
    { type: "img", src: irbid1 },
    { type: "img", src: irbid3 },
    { type: "img", src: irbid4 },
    { type: "img", src: irbid5 },
    { type: "img", src: irbid6 },
    { type: "img", src: irbid9 },
    
    { type: "video", src: irbid10 },
  ];

  const peekabooimages = [
    { type: "img", src: peekaboo2 },
    { type: "img", src: peekaboo5 },
    { type: "img", src: peekaboo11 },
    { type: "img", src: peekaboo14 },
    { type: "img", src: peekaboo17 },
    { type: "img", src: peekaboo18 },
    { type: "img", src: peekaboo19 },
    { type: "img", src: peekaboo20 },
    { type: "img", src: peekaboo22 },
    { type: "img", src: peekaboo25 },
    
    { type: "video", src: peekaboo31 },
    { type: "video", src: peekaboo32 },
  ];

    const [currentIndex, setCurrentIndex] = useState(null);


  const openViewer = (index,client) => {
  if(client=="babyday"){
   setimages(babydayimages)
    
  }
  else if(client=="peekaboo"){
   setimages(peekabooimages)
    
  }
  else if(client=="irbid"){
   setimages(irbidimages)
  }

  setCurrentIndex(index);
  
};
  const closeViewer = () => setCurrentIndex(null);
  const showPrev = () =>
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  const showNext = () =>
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  


     const [isOpen, setIsOpen] = useState(false);
     const [images, setimages] = useState();

  
   
  
  
  
  return (
  <div className='Projects'>
    <Helmet>
        <meta name="playground equipment catalog" content="GEM is a leading playground equipment company, offering the 
          highest quality trampolines designed for durability, safety, and fun
          for all ages" />
          
                      </Helmet>
    <Header/>
    <Dashboard title={"Projects"} imageUrl={project} description={description}/>
      <WhatsappButton
          altText="Chat with us on WhatsApp"
          iconSize={70}
        />
    <Link to="/getquotations" style={{ textDecoration: 'none', color: 'inherit' }}>
            <div className="icon-container">
              <img
                src={plusicon}
                alt="plusicon"
                className="Producticon"
                style={{ cursor: "pointer" }}
              />
              <button className="quotation-button">Get Quotation</button>
            </div>
          </Link>
    
    <Cardlist/>

      


    
     <div>

      {/* Viewer (Portal) */}
      {currentIndex !== null &&
        images[currentIndex] &&
        createPortal(
          <div className="viewer-overlay">
            <button onClick={closeViewer} className="close-btn">✕</button>



             <div className="viewer-content">
        {/* Prev button */}
        <button
          className="nav-btn left"
          onClick={() =>
            setCurrentIndex((currentIndex - 1 + images.length) % images.length)
          }
        >
          ‹
        </button>

        {/* Image or video */}
        {images[currentIndex].type === "img" ? (
          <img src={images[currentIndex].src} alt="" />
        ) : (
          <video
            src={images[currentIndex].src}
            controls
            autoPlay
            loop
            muted
          />
        )}

        {/* Next button */}
        <button
          className="nav-btn right"
          onClick={() =>
            setCurrentIndex((currentIndex + 1) % images.length)
          }
        >
          ›
        </button>
      </div>
          </div>,
          document.body
        )}
    </div>





     <section className="project-page1" id="babydaydiv">
      <h2 className="project-title1">Baby Day</h2>
 

        



      <div className="project-images1">
         
        {babydayimages.map((item, index) =>
    item.type === "img" ? (
      <img
        key={index}
        src={item.src}
        alt="Project Thumbnail"
        className="project-image1"
        onClick={() => openViewer(index,"babyday")}
      />
    ) : (
      <video
        key={index}
        src={item.src}
        className="project-image1"
        onClick={() => openViewer(index,"babyday")}
        autoPlay={false} loop muted
      />
        )
      )}

   


        {/* <img src={babyday2} alt="Project 1" className="project-image1" />
        
        <img src={babyday15} alt="Project 1" className="project-image1" />
        <img src={babyday12} alt="Project 1" className="project-image1" />
        <img src={babyday8} alt="Project 1" className="project-image1" />
        
        
        <img src={babyday14} alt="Project 1" className="project-image1" />
        <img src={babyday16} alt="Project 1" className="project-image1" />
        <img src={babyday18} alt="Project 1" className="project-image1" />
        <video className="project-image1" src={babyday19} controls autoPlay={false} loop muted /> */}

        
      </div>
     </section>


      <section className="project-page1" id="peekaboodiv">
      <h2 className="project-title1">Peekaboo</h2>
      <div className="project-images1">

         {peekabooimages.map((item, index) =>
    item.type === "img" ? (
      <img
        key={index}
        src={item.src}
        alt="Project Thumbnail"
        className="project-image1"
        onClick={() => openViewer(index,"peekaboo")}
      />
    ) : (
      <video
        key={index}
        src={item.src}
        className="project-image1"
        onClick={() => openViewer(index,"peekaboo")}
        autoPlay={false} loop muted
      />
        )
      )}
        

{/*         
        <img src={peekaboo2} alt="Project 1" className="project-image1" />
        <img src={peekaboo5} alt="Project 1" className="project-image1" />
        <img src={peekaboo11} alt="Project 1" className="project-image1" />
        <img src={peekaboo14} alt="Project 1" className="project-image1" />
        <img src={peekaboo17} alt="Project 1" className="project-image1" />
        <img src={peekaboo18} alt="Project 1" className="project-image1" />
        <img src={peekaboo19} alt="Project 1" className="project-image1" />
        <img src={peekaboo20} alt="Project 1" className="project-image1" />
        <img src={peekaboo22} alt="Project 1" className="project-image1" />
        <img src={peekaboo25} alt="Project 1" className="project-image1" />
       
        <video className="project-image1" src={peekaboo31} controls autoPlay={false} loop muted />
        <video className="project-image1" src={peekaboo32} controls autoPlay={false} loop muted /> */}
      </div>
     </section>
    

      <section className="project-page1" id="irbiddiv">
      <h2 className="project-title1">Irbid Landmark</h2>
      <div className="project-images1">

         {irbidimages.map((item, index) =>
    item.type === "img" ? (
      <img
        key={index}
        src={item.src}
        alt="Project Thumbnail"
        className="project-image1"
        onClick={() => openViewer(index,"irbid")}
      />
    ) : (
      <video
        key={index}
        src={item.src}
        className="project-image1"
        onClick={() => openViewer(index,"irbid")}
        autoPlay={false} loop muted
      />
        )
      )}

        {/* <img src={irbid1} alt="Project 1" className="project-image1" />
        <img src={irbid3} alt="Project 1" className="project-image1" />
        <img src={irbid4} alt="Project 1" className="project-image1" />
        <img src={irbid5} alt="Project 1" className="project-image1" />
        <img src={irbid6} alt="Project 1" className="project-image1" />
      
        <img src={irbid9} alt="Project 1" className="project-image1" />
        <video className="project-image1" src={irbid10} controls autoPlay={false} loop muted /> */}

      </div>
     </section>

      

     

    <Footer/>

     </div>
  );
}
export default Projects;

